import React from 'react';
import { View, Image } from 'react-native';
import Typography from 'src/components/Text/Text';
import BottomModal from 'src/components/BottomModal/BottomModal';
import { styles } from './QuoteSuccessModal.styles';
import successTick from 'src/assets/success_tick.png';
import Button from 'src/components/Button/Button'; // assuming you have a Button component

interface QuoteSuccessModalProps {
  isVisible: boolean;
  onClose: () => void;
}

const QuoteSuccessModal: React.FC<QuoteSuccessModalProps> = ({ isVisible, onClose }) => {
  return (
    <BottomModal isVisible={isVisible} onClose={onClose} title="">
      <View style={styles.container}>
        {/* Icon with halo */}
        <View style={styles.iconWrapper}>
          <Image source={successTick} style={styles.icon} />
        </View>

        {/* Title */}
        <Typography variant="h2" style={styles.title}>
          Thanks! A Specialist Will Contact You Soon
        </Typography>

        {/* Description */}
        <Typography variant="body1" style={styles.description}>
          One of our trucking insurance specialists will call you shortly!
        </Typography>

        {/* Button */}
        <Button
          type="primary"
          size="big"
          title="Got it"
          onPress={() => onClose()}
          style={styles.button}
        />
      </View>
    </BottomModal>
  );
};

export default QuoteSuccessModal;
